import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            info: null,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, info: error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    render() {
        const { hasError, info } = this.state;
        const { children, fallback: Fallback } = this.props;
        if (hasError) {
            // Only use a caller-supplied fallback when one is actually passed; rendering
            // an undefined component here would throw React #130 and mask the real error.
            if (Fallback) return <Fallback error={info} />;
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '100vh',
                        padding: '24px',
                        textAlign: 'center',
                        fontFamily: 'sans-serif',
                        gap: '12px',
                    }}>
                    <h2 style={{ margin: 0, fontSize: '18px' }}>Something went wrong</h2>
                    <p style={{ margin: 0, color: '#666' }}>Please reload the page and try again.</p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: '8px',
                            padding: '8px 20px',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            background: '#fff',
                            cursor: 'pointer',
                        }}>
                        Reload
                    </button>
                </div>
            );
        }
        return children;
    }
}

export default ErrorBoundary;
